export default {
  path: 'docs',
  label: '接口文档',
  icon: 'fa fa-cube',
  meta: {
    apiName: 'get_vipflow'
  },
  component: {
    render () {
      return <router-view />
    }
  },
  children: [
    {
      name: 'give_vip',
      path: 'give_vip',
      label: '会员直充接口',
      link: 'https://docs.qq.com/doc/DWEl3eWZrUmdXaVF0?opendocxfrom=admin',
      meta: {
        apiName: 'get_vipflow',
      },
      // component: () => import('../views/docs/give-vip')
      // link: 'http://cc.video.qq.com/api/v1/doc/give_vip.html'
    },
    {
      name: 'give_coupon',
      path: 'give_coupon',
      label: '代金券直充接口',
      link: 'https://docs.qq.com/doc/DWGZsZGp5d0hUQVl5?opendocxfrom=admin',
      meta: {
        apiName: 'get_vipflow',
      },
      // link: 'http://cc.video.qq.com/api/v1/doc/give_coupon.html',
      // component: () => import('../views/docs/give-coupon')
    }
  ]
}
